export default {
    SourcingDetails: {
        Basic: '基本信息',
        Specify: '指定发货',
        order: '客户订单号',
        Internal: '内部订单号',
        Doc: '寻源单号',
        creation: '寻源创建时间',
        Reason: '寻源失败原因',
        product: '寻源商品信息',
        All: '全部',
        form: {
            Summarize: '按商品汇总',
            line: '按商品行明细',
            status: '寻源状态',
            // name: '商品名称',
            // code: '商品编码',
            SKU: 'SKU名称',
            SKUcode: 'SKU编码',
            quantity: '商品数量',
            Whether: '是否赠品',
            warehouse: '发货逻辑仓编码',
            Shipment: '发货逻辑仓名称',
            Failure: '失败原因',
            Gift: '赠',
            Total: '商品行总数：',
            Other: '其它信息',
            returned: '返回数据为空，请联系管理员',
        }
    }
};
